export default "__VITE_ASSET__CYNdskzJ__"